import { Button } from "../../components/Button";
import React from "react";
import { Password } from "./components/Password";
import { ShowToast } from "../../services/toast";
import { ResetPasswordSuccess } from "./components/ResetPasswordSuccess";
import { Header } from "./components/Header";
import passwordValidation from "./register/Register";
import { TextInput } from "../../components/TextInput";
import { useApp } from "../../services/app-context";

export function ResetPassword() {
  const [errors, setErrors] = React.useState({} as any);
  const [disabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [isPasswordSame, setIsPasswordSame] = React.useState<string>("");
  const { cognitoUserRef } = useApp();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // get the form data
    const formData = new FormData(e.currentTarget);
    // convert the form data to an object
    const data = Object.fromEntries(formData);
    // log the results
    try {
      setLoading(true);
      const code = data.code as string;
      const password = data.password as string;

      cognitoUserRef.current?.confirmPassword(code, password, {
        onSuccess: () => {
          setLoading(false);
          setSuccess(true);
        },
        onFailure: (error) => {
          setLoading(false);
          ShowToast({
            type: "error",
            message: error.message,
          });
        },
      });
    } catch (error: any) {
      ShowToast({
        type: "error",
        message:
          error?.response?.data?.message ||
          "Unable to reset password, please try again later",
      });
      setLoading(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLFormElement>) => {
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData);
    if (e.target.name === "password") {
      if (!passwordValidation(data.password.toString())) {
        setErrors((prev) => ({
          ...prev,
          password:
            "Password should contain at least 8 characters, 1 letter, 1 number and 1 special character",
        }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
      }
    }
    if (e.target.name === "confirmPassword") {
      if (!passwordValidation(data.confirmPassword.toString())) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword:
            "Password should contain at least 8 characters, 1 letter, 1 number and 1 special character",
        }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
      }
    }
    if (
      data.password &&
      data.confirmPassword &&
      data.password === data.confirmPassword &&
      passwordValidation(data.password.toString()) &&
      passwordValidation(data.confirmPassword.toString()) &&
      (data?.code as string)?.length === 6
    ) {
      setIsPasswordSame("");
      setDisabled(false);
    } else {
      if (
        data.password &&
        data.confirmPassword &&
        data.password !== data.confirmPassword
      ) {
        setIsPasswordSame("Password does not match");
      } else {
        setIsPasswordSame("");
      }
      setDisabled(true);
    }
  };

  return (
    <div className="h-screen bg-background">
      <Header showSignIn />
      <div className="flex flex-col max-h-[calc(100vh_-_100px)] overflow-auto">
        <div className="flex justify-center items-center min-h-[calc(100vh-150px)]">
          {success ? (
            <ResetPasswordSuccess />
          ) : (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col"
              onChange={handleChange}
            >
              <div className="rounded-lg w-[438px] p-8 bg-white flex flex-col mx-3">
                <div className="text-text-primary text-[28px] font-bold leading-loose">
                  Reset Password
                </div>
                <span className="text-text-primary/80 text-sm font-normal leading-normal ">
                  Reset your password below.
                </span>
                <div className="my-6 flex flex-col gap-5">
                  <div className="my-2 flex-1 flex flex-col gap-1.5">
                    <label htmlFor="password" className="text-sm text-text-primary/80">
                      Enter the 6 digit code from your authenticator app
                    </label>

                    <TextInput
                      type="text"
                      name="code"
                      maxLength={6}
                    />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <span className="text-text-primary text-xs font-medium">
                      New Password
                    </span>
                    <Password
                      placeholder="Create a new password"
                      className="!p-[14px]"
                      name="password"
                    />
                    {errors.password && (
                      <div className="text-red-500 text-xs font-medium">
                        {errors.password}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <span className="text-text-primary text-xs font-medium">
                      Confirm Password
                    </span>
                    <Password
                      type="password"
                      placeholder="Re-enter the password"
                      className="!p-[14px]"
                      name="confirmPassword"
                    />
                    {isPasswordSame && (
                      <span className="text-red-500 text-xs font-medium">
                        {isPasswordSame}
                      </span>
                    )}
                  </div>
                </div>
                <Button
                  disabled={disabled}
                  loading={loading}
                  className="!rounded-full w-full"
                  variant="primary"
                >
                  Reset
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
